import React, { useState, useEffect } from 'react';
import { FaCheck, FaWindowClose } from 'react-icons/fa';
import ErrorHandler from '../../services/ErrorHandler';
import { makeGetRequest } from '../../services/httpHelper';
import { Container, Row, Col, Card } from 'react-bootstrap';
import FullButton from '../Buttons/FullButton';
import { toTitleCase } from '../../utils/myFunctions';
import getVisitorCountry from '../../utils/getVisitorCountry';
import { KES_CURRENCY_SYMBOL, USD_CURRENCY_SYMBOL, USD_TO_KES_EX_RATE } from '../../constants/config';
import formatCurrency from '../../utils/formatCurrency';

const SubscriptionFeatureCard = ({ data }) => {
  const [country, setCountry] = useState(null);

    const planName = data?.plan?.plan?.trim().toLowerCase();
  const isCustomPlan = planName === 'enterprise';

  const getCountry = async () => {
    const countryCode = await getVisitorCountry();
    setCountry(countryCode);
  };

useEffect(() => {
  getCountry();



}, []); // <- Important to re-run when data changes


  


  return (
    <Container fluid className="subscription-page">
      <Row>
        <Col md={{ span: 12 }}>
          <Card className="subscription-card">
            <Card.Header>
              <Card.Title className="text-center" style={{ fontWeight: 'bold', fontSize: '30px', color: '#f97316' }}>
                {toTitleCase(data.plan.plan)}
              </Card.Title>
            </Card.Header>
            <Card.Body className='mx-auto'>
              {!isCustomPlan ? <p>Up to {data.plan.max_member_count} Members</p>:<p> {data.plan.max_member_count}+ Members</p>}
  {isCustomPlan? (
    <>
      <p style={{ fontSize: "35px", fontWeight: "bold" }}>
        Custom Pricing <span style={{ fontSize: "14px", fontWeight: "normal" }}> Per Month</span>
      </p>
      <p>{data.plan.description}</p>
    </>
  ) : (
    <>
      <p style={{ fontSize: "35px", fontWeight: "bold" }}>
        {country === 'KE' ? KES_CURRENCY_SYMBOL : USD_CURRENCY_SYMBOL}
        {country === 'KE'
          ? formatCurrency((data.plan.monthly_fee || 0) * USD_TO_KES_EX_RATE)
          : formatCurrency(data.plan.monthly_fee || 0)}
        <span style={{ fontSize: "14px", fontWeight: "normal" }}> Per Month</span>
      </p>
      <p>{data.plan.description}</p>
    </>
  )}

 {!isCustomPlan &&  <div className="mt-4">
    <h6>Optional Features:</h6>
    <ul>
      <li>SMS Integration (one-time setup fee + SMS credits)</li>
      <li>M-PESA Integration (one-time setup fee)</li>
    </ul>
  </div>}
</Card.Body>


            <Card.Footer>
              {
                isCustomPlan ?
                <>
                <a href='/#contact'>
                <FullButton title='Contact Us' />
              </a>
                </>
                :
                <>
                <a href='https://churchsuite.roshtech.co.ke/signup' target='_blank'>
                <FullButton title='Get Started' />
              </a>
                </>
              }
            </Card.Footer>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default SubscriptionFeatureCard;
